var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AppConsts } from '../../../shared/AppConsts';
var GraphListComponent = /** @class */ (function () {
    function GraphListComponent() {
        this.graphSelected = new EventEmitter();
    }
    GraphListComponent.prototype.getUrl = function (url) {
        return AppConsts.remoteServiceBaseUrl + url;
    };
    __decorate([
        Input()
    ], GraphListComponent.prototype, "graphList", void 0);
    __decorate([
        Input()
    ], GraphListComponent.prototype, "selectedGraphId", void 0);
    __decorate([
        Output()
    ], GraphListComponent.prototype, "graphSelected", void 0);
    GraphListComponent = __decorate([
        Component({
            selector: 'graph-list',
            template: "<div *ngFor=\"let graph of graphList\" class=\"graphList\" (click)=\"graphSelected.emit(graph)\"> <div [class.selectedGallery]=\"graph.id==selectedGraphId\" class=\"graph\"> <img *ngIf=\"graph.thumbUrl\" crossorigin=\"anonymous\" src=\"{{getUrl(graph.thumbUrl)}}\" alt=\"\" width=\"100%\" height=\"100%\"> </div> <span class=\"span-inline-block font12Size\">{{graph.name}}</span> </div> ",
            styles: [" .graphList { text-align: center; float: left; width: 64px; height: 100px; margin-left: 10px; margin-top: 10px; .graph { width: 64px; height: 64px; border: 2px solid transparent; display: flex; cursor: pointer; justify-content: center; .svgGraph>svg { width: 100%; height: 100%; } img{ width: auto; height: auto; max-width: 100%; max-height: 100%; align-self: center; } } span { font-size: 12px; word-break: break-word; } .graph.selectedGallery { border-color: #2d89ef; } } .inline-control{ display: inline-block; }"]
        })
    ], GraphListComponent);
    return GraphListComponent;
}());
export { GraphListComponent };
